import {
  useListOrganizations,
  useListProviders,
  useListUsersByOrganization,
  useListRolesByOrganization,
} from 'api/resource';
import { User, Organization, Role } from 'interfaces';
import { useCurrentSiteStore } from 'store';

export const useAdminUserManagementData = () => {
  const { organizationID } = useCurrentSiteStore();

  const {
    data: users = [] as User[],
    isLoading: loadingUsers,
    isError: userError,
    error: userErrorData,
  } = useListUsersByOrganization({ orgID: organizationID });

  const {
    data: organizations = [] as Organization[],
    isError: organizationError,
    isLoading: loadingOrganizations,
  } = useListOrganizations({
    isAdmin: true,
    organizationID: organizationID || '',
  });

  const {
    data: roles = [] as Role[],
    isError: roleError,
    isLoading: loadingRoles,
  } = useListRolesByOrganization({ organizationID: organizationID });

  const {
    data: providers = [],
    isError: providerError,
    isLoading: loadingProviders,
  } = useListProviders({});

  const isLoading =
    loadingUsers || loadingOrganizations || loadingRoles || loadingProviders;
  const isError = userError || organizationError || roleError || providerError;
  const errorMessage = userErrorData?.message;

  return {
    users,
    organizations,
    roles,
    providers,
    isLoading,
    isError,
    errorMessage,
  };
};
